import GokuDataGrid from '@/components/GokuDataGrid'
import { useFilePreviewWithPresigned } from '@/hooks/useFilePreviewWithPresigned'
import DownLoadIcons from '@/icons/DownLoadIcons'
import EyeIcons from '@/icons/EyeIcons'
import ServiceReceiptIcons from '@/icons/ServiceReceiptIcons'
import { getContractCustomerTypes } from '@/modules/Contract/services/customer'
import { ContractStatus, CustomerContract } from '@/modules/Contract/types'
import { useCallback } from 'react'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { IAction } from 'vnetwork-ui/dist/components/GokuDataGrid/Actions'
import { onPreview } from '../../Detail/Attachment/columns'
import { customerContractColumns } from './columns'
import Filters from './Filters'
import dayjs from 'dayjs'

const paramsTypeToStatus = (type?: string): string => {
    switch (type) {
        case 'new':
            return 'pending'
        case 'completed':
            return 'active'
        default:
            return type || ''
    }
}
const today = dayjs()
const List = () => {
    const { type } = useParams<{ type: string }>()
    const { t } = useTranslation()
    const { openFilePreview, downloadFileWithPresigned } =
        useFilePreviewWithPresigned()
    const handlePreview = useCallback(
        async (row: CustomerContract) => {
            const attachments = row?.attachments?.filter(
                (attachment) => !attachment?.attachment_closed
            )
            if (attachments?.length === 1) {
                const attachment = attachments[0]
                onPreview(
                    row?.contract_id,
                    `Xem hợp đồng - ${attachment?.attachment_file_name}`
                )
                await openFilePreview(attachment)
            } else {
                toast.error(`has-more-one-attachment`)
            }
        },
        [openFilePreview]
    )

    const handleDownload = useCallback(
        async (row: CustomerContract) => {
            const attachments = row?.attachments?.filter(
                (attachment) => !attachment?.attachment_closed
            )
            if (attachments?.length === 1) {
                const attachment = attachments[0]
                onPreview(
                    row?.contract_id,
                    `Tải hợp đồng - ${attachment?.attachment_file_name}`
                )
                await downloadFileWithPresigned(attachment)
            } else {
                toast.error(`has-more-one-attachment`)
            }
        },
        [downloadFileWithPresigned]
    )

    const dataGridActions: IAction<CustomerContract>[] = [
        {
            onClick: handlePreview,
            disabled: (row) => row?.contract_status !== ContractStatus.Active,
            title: t('contract-preview'),
            color: 'info',
            icon: <EyeIcons />,
        },
        {
            onClick: handleDownload,
            disabled: (row) => row?.contract_status !== ContractStatus.Active,
            title: t('download-file'),
            color: 'info',
            icon: <DownLoadIcons />,
        },
        {
            onClick: () => {},
            disabled: (row) => row?.contract_status !== ContractStatus.Active,
            title: t('contract-renew'),
            color: 'info',
            icon: <ServiceReceiptIcons />,
        },
    ]
    return (
        <GokuDataGrid
            apiCall={async (payload) =>
                getContractCustomerTypes({
                    values: payload,
                    status: paramsTypeToStatus(type),
                })
            }
            reactQueryKey={`contracts.customers.types.${type}`}
            columns={customerContractColumns(t)}
            dataGridProps={{
                getRowId: (row) => row?.contract_id,
            }}
            filterDefaultValues={{
                contract_id: [],
                contract_number_id: [],
                contract_key: [],
                employee_id: [],
                product_group_name: [],
                created_at: [today.startOf('month'), today.endOf('month')],
            }}
            actions={dataGridActions}
        >
            {({ control }) => {
                return <Filters control={control} />
            }}
        </GokuDataGrid>
    )
}

export default List
